import React, { Fragment, Component } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Collapse,
  ButtonGroup,
  Alert,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { ErrorAlert } from "../../../../../helpers/ui/alert_new";
import Select from "../../../../../helpers/ui/CustomSelect";
import {
  FileInput,
  generateFormData,
  generateFormDataMultiple,
} from "../../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { withRouter } from "react-router-dom";
import apiResponse from "../../../../../services/apiResponse";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";
import IndexBloc from "../../Index/Blocs/IndexBloc";
import CreateBloc from "../Blocs/CreateBloc";
import DatePicker from "../../../../../helpers/ui/DatePicker";
import _ from "lodash";

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  if (date) {
    return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
  }
  //console.log(dt);
  return "-";
};
var reformatOptions = (raw, label, value) => {
  return raw.map(function (data) {
    var newObj = {};
    if (data["position_grade"] != null && data["position_grade"] > 0) {
      newObj["label"] = data[label] + " (Grade " + data["position_grade"] + ")";
    } else {
      newObj["label"] = data[label];
    }

    newObj["value"] = data[value];
    newObj["model"] = data;
    //console.log(newObj);
    return newObj;
  });
};
class CreateModal extends Component {
  indexBloc = new IndexBloc();
  createBloc = new CreateBloc();
  timer;
  source;
  defaultSize = 10;

  constructor(props) {
    super(props);
    this.state = {
      selectedEmployee: null,
      detailMutasi: null,
      dataForm: null,
      employeeOption: [],
      workUnitOption: [],
      positionOption: [],
      jabatanOption: [],
      selectedMinistry: 1,
      countryOption: [],
      coupleOption: [],
      childOption: [],
      selectedChild: null,
      pemberhentianType: null,
      show_jenis_jabatan: 1,
      selected_jabatan: null,
      type: null,
      employeeFilter: {
        filter_value: "",
        page_number: 1,
        page_size: this.defaultSize,
        sort_order: {
          column: "employee_id",
          order: "asc",
        },
      },
      workUnitFilter: {
        filter_value: "",
        page_number: 1,
        page_size: this.defaultSize,
        sort_order: {
          column: "work_unit_id",
          order: "asc",
        },
      },
      positionFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 9999,
        sort_order: {
          column: "position_id",
          order: "asc",
        },
      },
      position_type: 1,
      quota: -1,
      msg: "",
      is_internal: 0,
      is_pppk: 0,
      perpanjang_kontrak_is_checked: false,
      //tambahan untuk cheklist AK
      isResetAk: false,
      modalResetAk: false,
      confirmResetAk: false
    };
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        uuid: this.props.uuid,
        employee_transfer_detail_uuid: this.props.detailUuid,
        employee_transfer_detail_ministry: this.state.selectedMinistry,
        ...values,
      },
      confirm: true,
    });
  };

  handlePegawaiSelected = (employee_uuid) => {
    let selected = employee_uuid.value;
    // console.log(selected);
    // if (selected == "Dalam Negeri") {
    //     this.setState({
    //         birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
    //         isLocal: 1
    //     })
    // } else {
    //     this.setState({
    //         birthSelectedCountry: "",
    //         isLocal: 0
    //     })
    // }
  };
  loadEmployee = async () => {
    const query = {
      uuid: this.props.uuid,
    };
    this.setState({ loadingEmployee: true });
    await this.indexBloc.fetchListPegawai(query);
  };

  loadWorkUnit = async () => {
    let offset =
      (this.state.workUnitFilter.page_number - 1) *
      this.state.workUnitFilter.page_size;
    const query = {
      search: this.state.workUnitFilter.filter_value,
      limit: this.state.workUnitFilter.page_size,
      offset: offset,
      order: this.state.workUnitFilter.sort_order.column,
      sort: this.state.workUnitFilter.sort_order.order,
      status: 1,
    };
    this.setState({ loadingWorkUnit: true });
    await this.indexBloc.fetchListUnitKerja(query);
  };

  loadPosition = async (uuid) => {
    // console.log("wu uuid : " + uuid);
    // console.log("load posisi : " + this.state.position_type);

    if (this.state.selectedEmployee) {
      if (uuid == "") {
        uuid = this.state.selectedEmployee.employee_current_work_unit_uuid;
      }
      // console.log('ghany')
      // console.log(this.state.selectedEmployee)
    }
    //console.log(this.state.detailMutasi?);
    let offset =
      (this.state.positionFilter.page_number - 1) *
      this.state.positionFilter.page_size;
    const query = {
      uuid: uuid,
      search: this.state.positionFilter.filter_value,
      limit: this.state.positionFilter.page_size,
      offset: offset,
      order: this.state.positionFilter.sort_order.column,
      sort: this.state.positionFilter.sort_order.order,
      status: 1,
      position_type: this.state.position_type,
    };
    this.setState({ loadingPosition: true });
    await this.indexBloc.fetchListJabatan(query);
  };

  loadRegion = async () => {
    await this.indexBloc.fetchRegion({ type: 1 });
  };

  loadGrade = async () => {
    await this.createBloc.fetchGrade();
  };

  loadStatus = async (type, stop ) => {
    await this.createBloc.fetchStatusList({
      type: type,
      stop: stop,
    });
  };

  loadLegal = async () => {
    await this.createBloc.fetchLegalList();
  };

  loadFamilyOptions = async () => {
    if (this.state.selectedEmployee) {
      await this.indexBloc.fetchCouple({
        status: 1,
        employee_uuid: this.state.selectedEmployee?.employee_uuid,
        order: "id",
        limit: 100,
      });
      await this.indexBloc.fetchChild({
        status: 1,
        uuid: this.state.selectedEmployee?.employee_uuid,
        order: "family_id",
        limit: 100,
      });
    }
  };

  loadDetail = async (uuid) => {
    const query = {
      uuid: uuid,
    };
    await this.indexBloc.fetchDetailMutasi(query);
  };
  handleAlasanPemberhentian = async (value) => {
    this.setState({ show_jenis_jabatan: 1 });
    // console.log("Alasan Pemberhentian = " + value);

    if (value == 1) {
      this.setState(
        {
          show_jenis_jabatan: 0,
          position_type: 2,
          selected_jabatan: "c103a8f2-03a4-4572-ad4a-45270171975b",
        },
        function () {
          this.loadPosition("");
        }
      );
    } else {
      this.setState(
        {
          show_jenis_jabatan: 1,
          position_type: null,
          selected_jabatan: null,
        },
        function () {
          this.loadPosition("");
        }
      );
    }

    //let selected = employee_uuid.value;
    // if (selected == "Dalam Negeri") {
    //     this.setState({
    //         birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
    //         isLocal: 1
    //     })
    // } else {
    //     this.setState({
    //         birthSelectedCountry: "",
    //         isLocal: 0
    //     })
    // }
  };

  convertToFormData(data) {
    const formData = new FormData();

    for (const key in data) {
      const value = data[key];
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (Array.isArray(item)) {
              item.forEach((itm, idx) => {
                if (itm !== null && itm !== undefined) {
                  formData.append(`${key}[${index}][]`, itm);
                }
              });
            } else {
              formData.append(`${key}[]`, item);
            }
          });
        } else {
          formData.append(key, value);
        }
      }
    }

    return formData;
  }
  submitData = async () => {
    // const dataForm = generateFormData(this.state.dataForm, {field: "file", name: "employee_transfer_detail_kemenlu_decree_document"})
    //const formData = generateFormData(this.state.dataForm, ['file', 'employee_transfer_detail_kemenlu_decree_document'])
    const formData = this.convertToFormData({
      ...this.state.dataForm,
      uuid: this.props.uuid,
    });
    // const dataForm = generateFormData(this.state.dataForm, {
    //     field: "employee_transfer_detail_kemenlu_decree_document",
    //     name: "employee_transfer_detail_kemenlu_decree_document",
    //   });

    //   dataForm = generateFormData(dataForm, {
    //     field: "file",
    //     name: "file",
    //   });
    if (this.props.uuid === "") {
      await this.createBloc.fetchCreate(formData);
    } else {
      await this.createBloc.fetchCreateDetail(formData);
    }
  };

  // Pengecekkan quota pada peta jabatan
  checkQuota = async (uuid) => {
    await this.createBloc.checkPositionQuota({
      position_uuid: uuid,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  confirmResponse2 = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        // this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failedBmn: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadEmployee();
    this.loadWorkUnit();
    this.loadPosition("");
    this.loadGrade();
    this.loadStatus(1,1);
    this.loadLegal();
  };

  formatAssets = (assets) => {
    return assets
      .map((asset, index) => {
        return `<br><b>${index + 1}. ${
          asset.asset_name ? asset.asset_name : "-"
        }</b>`;
      })
      .join(""); // tanpa koma
  };

  emptyInfo = () => {
    this.setState({
      failedInfoBmn: "",
    });
  };

  toggleCheckbox = () => {
    this.setState({
      perpanjang_kontrak_is_checked: !this.state.perpanjang_kontrak_is_checked,
    });
  };

  getRequestAset = (uuid) => {
    const baseUrl = process.env.REACT_APP_SERVICE_BMN_URL;
    const appCode = process.env.REACT_APP_SERVICE_BMN_APPCODE;
    fetch(baseUrl + "/Integration/getRequestAset/json?uuid=" + uuid, {
      method: "GET",
      headers: {
        AppCode: appCode,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        return response.json(); // Convert response to JSON
      })
      .then((json) => {
        if (json.status) {
          if (typeof json.response === "string") {
            this.emptyInfo();
            // console.error("Error:", json.response);
          } else if (typeof json.response === "object" && json.response.data) {
            // Check if the data array is empty
            this.emptyInfo();
            if (
              Array.isArray(json.response.data) &&
              json.response.data.length === 0
            ) {
              // console.log("No data found:", json.response.message);
              this.emptyInfo();
            } else {
              // console.log("Data found:", json.response.data);

              this.setState({
                // pemberhentianType: null,
                failedBmn: true,
                failedInfoBmn:
                  "<b>" +
                  this.state.selectedEmployee.employee_full_name +
                  "</b>, memiliki aset yang belum di kembalikan pada<b> Sistem Informasi Barang Milik Negara (BMN)</b> sebagai berikut :" +
                  this.formatAssets(json.response.data),
              });
            }
          } else {
            this.emptyInfo();
            // console.error("Unexpected response structure:", json);
          }
        } else {
          this.emptyInfo();
          // console.error("Request failed:", json.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.emptyInfo();
      });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.props.setUuid(result.data.response.employee_transfer_uuid);
          this.submitData();
          // const formData = generateFormData(this.state.dataForm, ['file', 'employee_transfer_detail_kemenlu_decree_document'])
          // this.createBloc.fetchCreateDetail(
          //   generateFormData(
          //     {
          //       ...this.state.dataForm,
          //       uuid: result.data.response.employee_transfer_uuid,
          //     },
          //     [
          //       "file",
          //       "employee_transfer_detail_kemenlu_decree_document",
          //       "file_spp",
          //       "file_spmt",
          //       "file_spmj",
          //       "employee_transfer_detail_couple_document",
          //       "employee_transfer_detail_child_document"
          //     ]
          //   )
          // );
          break;
        default:
          break;
      }
    });

    this.createBloc.createDetailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState(
              {
                loading: false,
                success: true,
              },
              function () {
                this.props.handleReload();
              }
            );
          } else {
            this.setState({
              loading: false,
              failed: true,
              failedInfo: result.data.message,
            });
          }
          this.props.toggle();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedInfo: result.data.message,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.listPegawaiChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            employeeOption: result.data.response.result,
            loadingEmployee: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.listUnitKerjaChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            workUnitOption: result.data.response.result,
            loadingWorkUnit: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.listJabatanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            positionOption: result.data.response.result,
            loadingPosition: false,
          });
          this.setState({
            jabatanOption: reformatOptions(
              result.data.response.result,
              "position_name",
              "position_uuid"
            ),
          });

          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.detailMutasiChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let obj = this.state.employeeOption.find(
            (o) =>
              o.employee_uuid ===
              result.data.response.employee_transfer_detail_employee_uuid
          );
          this.setState({
            detailMutasi: result.data.response,
            selectedEmployee: obj,
            type: result.data.response.employee_transfer_detail_type,
            pemberhentianType:
              result.data.response.employee_transfer_detail_position_type,
            selectedMinistry:
              result.data.response.employee_transfer_detail_ministry,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.regionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            countryOption: result.data.response.result,
            loadingCountry: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.coupleChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            coupleOption: result.data.response.result,
            loadingCouple: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.childChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            childOption: result.data.response.result,
            loadingChild: false,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.downloadTempateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          this.setState({
            loading: false,
            // success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            // loading: false,
            failed: true,
            failedInfo: result.data.message,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });

    this.createBloc.gradeListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            gradeListOption: result.data?.response?.result,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });



    

    this.createBloc.checkPositionQuotaChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            quota: result.data?.response?.quota,
            msg: result.data?.response?.msg,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });


    
    this.createBloc.listStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            statusListOption: result.data?.response?.result,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });


    
    this.createBloc.listLegalChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            legalListOption: result.data?.response?.result,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });


  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.createDetailChannel?.unsubscribe();
    this.indexBloc.listPegawaiChannel?.unsubscribe();
    this.indexBloc.listUnitKerjaChannel?.unsubscribe();
    this.indexBloc.listJabatanChannel?.unsubscribe();
    this.indexBloc.detailMutasiChannel?.unsubscribe();
    this.indexBloc.regionChannel?.unsubscribe();
    this.indexBloc.coupleChannel?.unsubscribe();
    this.indexBloc.childChannel?.unsubscribe();
    this.createBloc.downloadTempateChannel?.unsubscribe();
    this.indexBloc.listStatusChannel?.unsubscribe();
    this.indexBloc.listLegalChannel?.unsubscribe();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.modal !== this.props.modal) {
      if (this.props.modal == false) {
        this.setState({
          selectedEmployee: null,
          type: null,
          dataForm: null,
          detailMutasi: null,
        });
      }
    }

    if (prevProps.detailUuid !== this.props.detailUuid) {
      if (this.props.detailUuid) {
        this.loadDetail(this.props.detailUuid);
      }
    }

    if (prevState.pemberhentianType !== this.state.pemberhentianType) {
      if (
        this.state.pemberhentianType == 1 ||
        this.state.pemberhentianType == 2 ||
        this.state.pemberhentianType == 3
      ) {
        this.setState({
          loadingCountry: true,
          loadingCouple: true,
          loadingChild: true,
        });
        this.loadRegion();
        this.loadFamilyOptions();
      }
    }
    if (prevState.selectedEmployee !== this.state.selectedEmployee) {
      this.setState({
        childOption: [],
        loadingChild: true,
        coupleOption: [],
        loadingCouple: true,
      });
      this.loadFamilyOptions();
    }
  }

  // Tambahkan method untuk toggle modal
  toggleModalResetAk = () => {
    this.setState(prevState => ({
      modalResetAk: !prevState.modalResetAk
    }));
  }

  handleConfirmResetAk = () => {
    this.setState({
      confirmResetAk: true,
      isResetAk: true,
      modalResetAk: false
    });
  }

  handleCancelResetAk = () => {
    this.setState({
      confirmResetAk: false,
      isResetAk: false,
      modalResetAk: false
    });
  }

  render() {
    const { selectedEmployee, type, detailMutasi } = this.state;
    return (
      <Fragment>
        <Modal
          isOpen={this.props.modal}
          size="xl"
          centered={true}
          toggle={this.props.toggle}
        >
          <ModalHeader toggle={this.props.toggle}>
            Tambah Mutasi Pegawai
          </ModalHeader>
          <ModalBody>
            <AvForm
              className="needs-validation"
              onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
            >
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Jenis Mutasi <span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  <Select
                    name="employee_transfer_detail_type"
                    options={[
                      { value: 1, label: "SK Pengangkatan Jabatan" },
                      {
                        value: 2,
                        label: "SK Pemberhentian & Pengangkatan Jabatan",
                      },
                      { value: 3, label: "SK Pemberhentian Jabatan" },
                    ]}
                    onChange={(opt) => {
                      this.setState({ type: opt.value }, () => {
                        if (opt.value === 1 || opt.value === 2) {
                          this.loadStatus(opt.value, 0);
                        }
                      });
                    }}
                       
                    defaultValue={detailMutasi?.employee_transfer_detail_type}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Pegawai <span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  <Select
                    name="employee_transfer_detail_employee_uuid"
                    options={this.state.employeeOption}
                    optionLabel="employee_full_name"
                    optionValue="employee_uuid"
                    onChange={(opt) => {
                      debugger;
                      if (
                        [1, 3, 4, 5, 6, 7].includes(
                          this.state.pemberhentianType
                        ) &&
                        type == 3
                      ) {
                        // 1 Tubel, 3 Pindah instansi, 4 Pensiun, 5 CLTN, 6 Meninggal Dunia, 7 Resign / Mengundurkan Diri
                        this.getRequestAset(opt.employee_uuid);
                      } else {
                        this.setState({
                          failedInfoBmn: "",
                        });
                      }
                      // console.log(opt.employee_current_work_unit_uuid)
                      this.loadPosition(opt.employee_current_work_unit_uuid);
                      this.setState({
                        selectedEmployee: opt,
                        is_internal: opt.is_internal,
                        is_pppk: opt.is_pppk,
                      });
                    }}
                    onInputChange={(value) => {}}
                    isLoading={this.state.loadingEmployee}
                    defaultValue={
                      detailMutasi?.employee_transfer_detail_employee_uuid
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>
              <Collapse isOpen={selectedEmployee && true}>
                {selectedEmployee != null && (
                  <Fragment>
                    <Row className="mb-3 mt-3">
                      <Label className="col-md-3 col-form-label">Nip</Label>
                      <Col md="9">
                        <Input
                          value={selectedEmployee.employee_nip}
                          type="text"
                          readOnly={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Nama</Label>
                      <Col md="9">
                        <Input
                          value={selectedEmployee.employee_full_name}
                          type="text"
                          readOnly={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Pangkat</Label>
                      <Col md="9">
                        <Input
                          value={
                            selectedEmployee.employee_current_rank_group_room
                          }
                          type="text"
                          readOnly={true}
                        />
                      </Col>
                    </Row>
                    {type == 1 && (
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Unit Kerja
                        </Label>
                        <Col md="9">
                          <Input
                            value={
                              selectedEmployee.employee_current_work_unit_name
                            }
                            type="textarea"
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                    )}
                    <hr />
                  </Fragment>
                )}
              </Collapse>

              <Collapse isOpen={selectedEmployee && type == 1 && true}>
                {selectedEmployee && type == 1 && (
                  <Fragment>
                    <Label>Informasi Jabatan Baru</Label>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label"></Label>
                      <Col md="9">
                        <ButtonGroup>
                          <Button
                            type="button"
                            color="primary"
                            onClick={() =>
                              this.setState({ selectedMinistry: 1 })
                            }
                            active={this.state.selectedMinistry === 1}
                          >
                            Kementerian Di Dalam BKPM
                          </Button>
                          <Button
                            type="button"
                            color="primary"
                            onClick={() =>
                              this.setState({ selectedMinistry: 2 })
                            }
                            active={this.state.selectedMinistry === 2}
                          >
                            Kementerian Di Luar BKPM
                          </Button>
                        </ButtonGroup>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Unit Kerja Baru <span className="text-danger">*</span>
                      </Label>
                      <Col md="9">
                        {this.state.selectedMinistry === 1 ? (
                          <Select
                            name="employee_transfer_detail_work_unit_uuid"
                            defaultValue={
                              detailMutasi
                                ? detailMutasi?.employee_transfer_detail_work_unit_uuid
                                : selectedEmployee.employee_current_work_unit_uuid
                            }
                            options={this.state.workUnitOption}
                            optionLabel="work_unit_name_reverse"
                            optionValue="work_unit_uuid"
                            errorMessage="Masukkan Unit Kerja Baru"
                            onChange={(opt) =>
                              this.loadPosition(opt.work_unit_uuid)
                            }
                            onInputChange={(value) => {
                              if (value) {
                                clearTimeout(this.timer);
                                this.state.workUnitFilter.filter_value = value;
                                this.timer = setTimeout(
                                  () => this.loadWorkUnit(),
                                  1000
                                );
                              }
                            }}
                            isLoading={this.state.loadingWorkUnit}
                            validate={{ required: { value: true } }}
                          />
                        ) : (
                          <AvField
                            name="employee_transfer_detail_work_unit_name"
                            type="text"
                            placeholder="Unit Kerja Baru..."
                            validate={{ required: { value: true } }}
                            value={
                              detailMutasi?.employee_transfer_detail_work_unit_name
                            }
                          />
                        )}
                      </Col>
                    </Row>
                    {this.state.selectedMinistry === 1 && (
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Jenis Jabatan <span className="text-danger">*</span>
                        </Label>
                        <Col md="9">
                          <Select
                            name="employee_transfer_detail_position_type"
                            options={[
                              { value: 1, label: "Struktural" },
                              { value: 2, label: "Fungsional Umum" },
                              { value: 20, label: "Fungsional Tertentu" },
                            ]}
                            errorMessage="Pilih Jenis Jabatan"
                            defaultValue={this.state.position_type}
                            onChange={(opt) =>
                              this.setState(
                                {
                                  position_type: opt.value,
                                },
                                () => this.loadPosition("")
                              )
                            }
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Jabatan <span className="text-danger">*</span>
                      </Label>
                      <Col md="9">
                        {this.state.selectedMinistry === 1 ? (
                          <Select
                            name="employee_transfer_detail_position_uuid"
                            options={this.state.jabatanOption}
                            //optionLabel="position_name"
                            //optionValue="position_uuid"
                            errorMessage="Pilih Jabatan"
                            defaultValue={
                              detailMutasi?.employee_transfer_detail_position_uuid
                            }
                            // onInputChange={value => {
                            //     if (value) {
                            //         clearTimeout(this.timer)
                            //         this.state.positionFilter.filter_value = value
                            //         this.timer = setTimeout(() => this.loadPosition(), 1000);
                            //     }
                            // }}
                            onChange={(selectedOption) => {
                              // Get the selected value here
                              const selectedValue = selectedOption.value;
                              console.log(
                                "Selected Position UUID: ",
                                selectedValue
                              );

                              // this.checkQuota(selectedValue);

                              // Update the state or do something with the selected value
                              // this.setState({
                              //   employee_transfer_detail_position_uuid: selectedValue
                              // });
                            }}
                            isLoading={this.state.loadingPosition}
                            validate={{ required: { value: true } }}
                          />
                        ) : (
                          <AvField
                            name="employee_transfer_detail_position_name"
                            type="text"
                            placeholder="Jabatan Baru..."
                            validate={{ required: { value: true } }}
                            value={
                              detailMutasi?.employee_transfer_detail_position_name
                            }
                          />
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col md="3"></Col>
                      <Col md="9">
                        {/* {this.state.quota >= 0 ? ( */}
                        <Alert color="warning" role="alert">
                          <i className="uil-info-circle"></i> Informasi Penting
                          :
                          <div
                            dangerouslySetInnerHTML={{
                              __html: this.state.msg ? this.state.msg : "",
                            }}
                          />
                        </Alert>
                        {/* ) : null} */}
                      </Col>
                    </Row>

                    {this.state.selectedMinistry !== 1 && (
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Tunjangan Kinerja{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Col md="9">
                          <AvField
                            name="employee_transfer_detail_allowance"
                            type="number"
                            placeholder="Tunjangan Kinerja..."
                            validate={{ required: { value: true } }}
                            value={
                              detailMutasi?.employee_transfer_detail_allowance
                            }
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Surat Keputusan<span className="text-danger">*</span>
                      </Label>
                      <Col md="9">
                        <Row>
                          <Col md="6">
                            <AvField
                              name="employee_transfer_detail_decree_number"
                              value={
                                detailMutasi?.employee_transfer_detail_decree_number
                              }
                              placeholder="Nomor SK"
                              type="text"
                              errorMessage="Masukkan No Surat Keputusan"
                              validate={{ required: { value: false } }}
                            />
                          </Col>
                          <Col md="6">
                            <div className="customDatePickerWidth">
                              <DatePicker
                                name="employee_transfer_detail_decree_date"
                                id="employee_transfer_detail_decree_date"
                                placeholder="Tanggal SK"
                                errorMessage="Masukkan Tanggal SK"
                                dateFormat="dd/MM/yyyy"
                                isWeekday={false}
                                value={
                                  detailMutasi?.employee_transfer_detail_decree_date
                                }
                                validate={{ required: { value: false } }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        TMT Jabatan <span className="text-danger">*</span>
                      </Label>
                      <Col md="9">
                        <div className="customDatePickerWidth">
                          <DatePicker
                            name="employee_transfer_detail_tmt_date"
                            id="employee_transfer_detail_tmt_date"
                            placeholder="Tanggal TMT Jabatan"
                            errorMessage="Masukkan Tanggal TMT Jabatan"
                            dateFormat="dd/MM/yyyy"
                            isWeekday={false}
                            validate={{ required: { value: true } }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload Surat Keputusan
                      </Label>
                      <Col md="9">
                        <FileInput
                          name="file"
                          validate={{ required: { value: false } }}
                          maxFiles={1}
                        />
                      </Col>
                    </Row>
                    {(this.state.position_type == 1 ||
                      this.state.position_type == 2 ||
                      this.state.position_type == 20) &&
                      (type == 1 || type == 2) && (
                        <Fragment>
                          {this.state.position_type == 1 &&
                            (type == 1 || type == 2) && (
                              <Fragment>
                                <Row className="mb-3">
                                  <Label className="col-md-3 col-form-label">
                                    Surat Pernyataan Pelantikan
                                  </Label>
                                  <Col md="9">
                                    <Row>
                                      <Col md="6">
                                        <AvField
                                          name="employee_transfer_detail_spp_number"
                                          value={
                                            detailMutasi?.employee_transfer_detail_spp_number
                                          }
                                          placeholder="Nomor SPP"
                                          type="text"
                                          errorMessage="Masukkan No Surat Pernyataan Pelantikan"
                                          validate={{
                                            required: { value: false },
                                          }}
                                        />
                                      </Col>
                                      <Col md="6">
                                        <div className="customDatePickerWidth">
                                          <DatePicker
                                            name="employee_transfer_detail_spp_date"
                                            id="employee_transfer_detail_spp_date"
                                            placeholder="Tanggal SPP"
                                            errorMessage="Masukkan Tanggal SPP"
                                            dateFormat="dd/MM/yyyy"
                                            isWeekday={false}
                                            validate={{
                                              required: { value: false },
                                            }}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>

                                <Row className="mb-3">
                                  <Label className="col-md-3 col-form-label">
                                    Upload Surat Pernyataan Pelantikan
                                  </Label>
                                  <Col md="9">
                                    <FileInput
                                      name="file_spp"
                                      validate={{ required: { value: false } }}
                                      maxFiles={1}
                                    />
                                  </Col>
                                </Row>
                              </Fragment>
                            )}
                          {(this.state.position_type == 1 ||
                            this.state.position_type == 20) &&
                            (type == 1 || type == 2) && (
                              <Fragment>
                                <Row className="mb-3">
                                  <Label className="col-md-3 col-form-label">
                                    Surat Pernyataan Menduduki Jabatan
                                  </Label>
                                  <Col md="9">
                                    <Row>
                                      <Col md="6">
                                        <AvField
                                          name="employee_transfer_detail_spmj_number"
                                          value={
                                            detailMutasi?.employee_transfer_detail_spmj_number
                                          }
                                          placeholder="Nomor SPMJ"
                                          type="text"
                                          errorMessage="Masukkan No Surat Pernyataan Menduduki Jabatan"
                                          validate={{
                                            required: { value: false },
                                          }}
                                        />
                                      </Col>
                                      <Col md="6">
                                        <div className="customDatePickerWidth">
                                          <DatePicker
                                            name="employee_transfer_detail_spmj_date"
                                            id="employee_transfer_detail_spmj_date"
                                            placeholder="Tanggal SPMJ"
                                            errorMessage="Masukkan Tanggal SPMJ"
                                            dateFormat="dd/MM/yyyy"
                                            isWeekday={false}
                                            validate={{
                                              required: { value: false },
                                            }}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                <Row className="mb-3">
                                  <Label className="col-md-3 col-form-label">
                                    Upload Surat Pernyataan Menduduki Jabatan
                                  </Label>
                                  <Col md="9">
                                    <FileInput
                                      name="file_spmj"
                                      validate={{ required: { value: false } }}
                                      maxFiles={1}
                                    />
                                  </Col>
                                </Row>
                              </Fragment>
                            )}

                          <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                              Surat Pernyataan Melaksakan Tugas
                            </Label>
                            <Col md="9">
                              <Row>
                                <Col md="6">
                                  <AvField
                                    name="employee_transfer_detail_spmt_number"
                                    value={
                                      detailMutasi?.employee_transfer_detail_spmt_number
                                    }
                                    placeholder="Nomor SPMT"
                                    type="text"
                                    errorMessage="Masukkan No Surat Pernyataan Melaksakan Tugas"
                                    validate={{ required: { value: false } }}
                                  />
                                </Col>
                                <Col md="6">
                                  <div className="customDatePickerWidth">
                                    <DatePicker
                                      name="employee_transfer_detail_spmt_date"
                                      id="employee_transfer_detail_spmt_date"
                                      placeholder="Tanggal SPMT"
                                      errorMessage="Masukkan Tanggal SPMT"
                                      dateFormat="dd/MM/yyyy"
                                      isWeekday={false}
                                      validate={{ required: { value: false } }}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                              Upload Surat Pernyataan Melaksakan Tugas
                            </Label>
                            <Col md="9">
                              <FileInput
                                name="file_spmt"
                                validate={{ required: { value: false } }}
                                maxFiles={1}
                              />
                            </Col>
                          </Row>
                        </Fragment>
                      )}
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Pejabat Penetap <span className="text-danger">*</span>
                      </Label>
                      <Col md="9">
                        <AvField
                          name="employee_transfer_detail_signatories_official"
                          value={
                            detailMutasi?.employee_transfer_detail_signatories_official
                          }
                          placeholder="Pejabat Penetap..."
                          type="text"
                          errorMessage="Masukkan Pejabat Penetap"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>





                    {(type == 1 || type == 2) && this.state.is_internal == 1 ? (
                      <>
                        <Row className="mb-3">
                          <label
                            htmlFor="mapping_grade_tunsus_grade_special_level_uuid"
                            className="col-md-3 col-form-label"
                          >
                            Grade Tunsus <span className="text-danger">*</span>
                          </label>
                          <Col md="3">
                            <Select
                              name="mapping_grade_tunsus_grade_special_level_uuid"
                              placeholder="Grade Tunsus..."
                              errorMessage="Grade Tunsus"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              options={this.state.gradeListOption}
                              optionLabel="special_level_code"
                              optionValue="special_level_uuid"
                              isLoading={!this.state.gradeListOption?.length}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label
                            htmlFor="mapping_grade_tunsus_grade_special_level_uuid"
                            className="col-md-3 col-form-label"
                          >
                            Berlaku Dari <span className="text-danger">*</span>
                          </label>
                          <Col md="3">
                            <AvField
                              name={`mapping_grade_tunsus_grade_start_date`}
                              type="date"
                              errorMessage="MasukkanTanggal Mulai Berlaku"
                              validate={{ required: { value: true } }}
                              placeholder="Tanggal Mulai Berlaku"
                            />
                          </Col>
                        </Row>
                        {/* Penambahan untuk PPPK  */}
                        {this.state.is_pppk === 1 && (
                          <>
                            {/* Penambahan untuk PPPK  */}
                            <Row className="mb-3">
                              <label
                                htmlFor="perpanjang_kontrak"
                                className="col-md-3 col-form-label"
                              >
                                Perpanjang Kontrak
                              </label>
                              <Col md="5">
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="perpanjang_kontrak_is_checked"
                                  value=""
                                  checked={
                                    this.state.perpanjang_kontrak_is_checked
                                  }
                                  onclick={(event) => {
                                    this.toggleCheckbox();
                                  }}
                                />
                                <AvField
                                  name="perpanjang_kontrak_is_checked"
                                  type="hidden"
                                  value={
                                    this.state.perpanjang_kontrak_is_checked
                                  }
                                />
                              </Col>
                            </Row>
                            {this.state.perpanjang_kontrak_is_checked ===
                              true && (
                              <>
                                <Row className="mb-3">
                                  <Label className="col-md-3 col-form-label">
                                    Tanggal TMT Berakhir{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Col md="9">
                                    <div className="customDatePickerWidth">
                                      <DatePicker
                                        name="employee_transfer_detail_tmt_date_end"
                                        id="employee_transfer_detail_tmt_date_end"
                                        placeholder="Tanggal TMT Berakhir"
                                        errorMessage="Masukkan Tanggal TMT Berakhir"
                                        dateFormat="dd/MM/yyyy"
                                        isWeekday={false}
                                        validate={{ required: { value: true } }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </>
                        )}


                      {/* Penambahan Pemadanan  */}
                      <Row className="mb-3">
                        <label
                          htmlFor="employee_transfer_detail_employee_status_uuid"
                          className="col-md-3 col-form-label"
                        >
                          Status Pegawai <span className="text-danger">*</span>
                        </label>
                        <Col md="3">
                          <Select
                            name="employee_transfer_detail_employee_status_uuid"
                            placeholder="Status Pegawai..."
                            errorMessage="Status Pegawai"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            options={this.state.statusListOption}
                            optionLabel="label"
                            optionValue="value"
                            isLoading={!this.state.statusListOption?.length}
                          />
                        </Col>
                      </Row>


                      <Row className="mb-3">
                        <label
                          htmlFor="employee_transfer_detail_legal_position_status_uuid"
                          className="col-md-3 col-form-label"
                        >
                          Kedudukan Hukum <span className="text-danger">*</span>
                        </label>
                        <Col md="3">
                          <Select
                            name="employee_transfer_detail_legal_position_status_uuid"
                            placeholder="Kedudukan Hukum..."
                            errorMessage="Kedudukan Hukum"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            options={this.state.legalListOption}
                            optionLabel="label"
                            optionValue="value"
                            isLoading={!this.state.legalListOption?.length}
                          />
                        </Col>
                      </Row>
                      
                      {/* Tambahan Untuk Reset Angka Kredit */}
                      <Row className="mb-3">
                          <label className="col-md-3 col-form-label"></label>
                          <Col md="8" className="d-flex align-items-center">
                            <div className="custom-checkbox">
                              <input
                                type="checkbox"
                                id="resetAkCheckbox"
                                checked={this.state.confirmResetAk}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    this.setState({ modalResetAk: true });
                                  } else {
                                    this.setState({
                                      isResetAk: false,
                                      confirmResetAk: false
                                    });
                                  }
                                }}
                              />
                              <label htmlFor="resetAkCheckbox">
                                Jika di checklist, maka akan mereset angka kredit
                              </label>
                            </div>
                            
                            {/* Hidden AvCheckbox untuk form validation */}
                            <AvCheckboxGroup
                              name="employee_transfer_detail_is_reset_ak"
                              value={this.state.confirmResetAk ? ["1"] : []}
                              style={{ display: 'none' }}
                            >
                              <AvCheckbox value="1" />
                            </AvCheckboxGroup>
                            
                            <style>
                              {`
                                .custom-checkbox {
                                  display: flex;
                                  align-items: center;
                                }
                                .custom-checkbox label {
                                  display: flex;
                                  align-items: center;
                                  font-size: 14px;
                                  line-height: 1.5;
                                  cursor: pointer;
                                  margin: 0;
                                  margin-left: 0;
                                }
                                .custom-checkbox input[type="checkbox"] {
                                  width: 16px;
                                  height: 16px;
                                  margin-right: 10px;
                                  margin-top: 0 !important;
                                  cursor: pointer;
                                  flex-shrink: 0;
                                }
                              `}
                            </style>
                          </Col>
                        </Row>


                      </>
                    ) : null}
                  </Fragment>
                )}
              </Collapse>

              <Collapse
                isOpen={selectedEmployee && (type == 2 || type == 3) && true}
              >
                {selectedEmployee && (type == 2 || type == 3) && (
                  <Fragment>
                    <Label>Informasi Jabatan Lama</Label>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Unit Kerja
                      </Label>
                      <Col md="9">
                        <AvField
                          name="employee_transfer_detail_old_work_unit_uuid"
                          type="hidden"
                          value={
                            selectedEmployee.employee_current_work_unit_uuid
                          }
                        />
                        <Input
                          value={
                            selectedEmployee.employee_current_work_unit_name
                          }
                          type="textarea"
                          readOnly={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Jabatan</Label>
                      <Col md="9">
                        <AvField
                          name="employee_transfer_detail_old_position_uuid"
                          type="hidden"
                          value={
                            selectedEmployee.employee_current_position_uuid
                          }
                        />
                        <Input
                          value={
                            selectedEmployee.employee_current_position_name
                          }
                          type="text"
                          readOnly={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Tanggal SK Lama
                      </Label>
                      <Col md="9">
                        <AvField
                          name="employee_transfer_detail_old_decree_date"
                          type="hidden"
                          value={selectedEmployee.position_history_decree_date}
                        />
                        <Input
                          value={reformatDate(
                            selectedEmployee.position_history_decree_date
                          )}
                          type="text"
                          readOnly={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        No SK Lama
                      </Label>
                      <Col md="9">
                        <AvField
                          name="employee_transfer_detail_old_decree_number"
                          type="hidden"
                          value={
                            selectedEmployee.position_history_decree_number
                          }
                        />
                        <Input
                          value={
                            selectedEmployee.position_history_decree_number
                          }
                          type="text"
                          readOnly={true}
                        />
                      </Col>
                    </Row>
                    <hr />
                    <Label>Informasi Jabatan Baru</Label>
                    {type == 2 && (
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label"></Label>
                        <Col md="9">
                          <ButtonGroup>
                            <Button
                              type="button"
                              color="primary"
                              onClick={() =>
                                this.setState({ selectedMinistry: 1 })
                              }
                              active={this.state.selectedMinistry === 1}
                            >
                              Kementerian Di Dalam BKPM
                            </Button>
                            <Button
                              type="button"
                              color="primary"
                              onClick={() =>
                                this.setState({ selectedMinistry: 2 })
                              }
                              active={this.state.selectedMinistry === 2}
                            >
                              Kementerian Di Luar BKPM
                            </Button>
                          </ButtonGroup>
                        </Col>
                      </Row>
                    )}
                    {type == 3 && (
                      <>
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            Alasan Pemberhentian
                            <span className="text-danger">*</span>
                          </Label>
                          <Col md="9">
                            <Select
                              name="employee_transfer_detail_stop_cause"
                              placeholder="Alasan Pemberhentian..."
                              errorMessage="Masukkan Alasan Pemberhentian"
                              // defaultValue={
                              //   detailMutasi?.employee_transfer_detail_stop_cause
                              // }
                              value={this.state.pemberhentianType}
                              validate={{ required: { value: true } }}
                              options={[
                                { value: 1, label: "Tugas Belajar" },
                                {
                                  value: 2,
                                  label: "Ditugaskan Di Luar Negeri/Luar BKPM",
                                },
                                { value: 3, label: "Pindah Instansi" },
                                { value: 4, label: "Pensiun" },
                                {
                                  value: 5,
                                  label: "Cuti di Luar Tanggunan Negara",
                                },
                                { value: 6, label: "Meninggal Dunia" },
                                {
                                  value: 7,
                                  label: "Resign / Mengundurkan diri",
                                },
                              ]}

                              onChange={(opt) => {
                                this.setState(
                                  { pemberhentianType: opt.value },
                                  () => {
                                    this.handleAlasanPemberhentian(opt.value);
                                    this.loadStatus(this.state.type, opt.value);
                                    if (
                                      [1, 3, 4, 5, 6, 7].includes(opt.value)
                                    ) {
                                      // 1 Tubel, 3 Pindah instansi, 4 Pensiun, 5 CLTN, 6 Meninggal Dunia  7 Resign / Mengundurkan Diri
                                      this.getRequestAset(
                                        selectedEmployee
                                          ? selectedEmployee.employee_uuid
                                          : ""
                                      );
                                    } else {
                                      this.setState({
                                        failedInfoBmn: "",
                                      });
                                    }
                                  }
                                );
                              }}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col md="3"></Col>
                          <Col md="9">
                            {this.state.failedInfoBmn ? (
                              <Alert color="warning" role="alert">
                                <i className="uil-info-circle"></i> Informasi
                                Penting :
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.failedInfoBmn
                                      ? this.state.failedInfoBmn
                                      : "",
                                  }}
                                />
                              </Alert>
                            ) : null}
                          </Col>
                        </Row>

                        {this.state.pemberhentianType == 1 && ( // Tugas Belajar
                          <>
                            <Row className="mb-3">
                              <Label className="col-md-3 col-form-label">
                                Tanggal Mulai Belajar
                                <span className="text-danger">*</span>
                              </Label>
                              <Col md="9">
                                <AvField
                                  name="employee_transfer_detail_study_start_date"
                                  value={
                                    detailMutasi?.employee_transfer_detail_study_start_date
                                  }
                                  placeholder="Tanggal Mulai Belajar..."
                                  type="date"
                                  errorMessage="Masukkan Tanggal Mulai Belajar"
                                  validate={{ required: { value: true } }}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Label className="col-md-3 col-form-label">
                                Tanggal Selesai Belajar
                                <span className="text-danger">*</span>
                              </Label>
                              <Col md="9">
                                <AvField
                                  name="employee_transfer_detail_study_end_date"
                                  value={
                                    detailMutasi?.employee_transfer_detail_study_end_date
                                  }
                                  placeholder="Tanggal Selesai Belajar..."
                                  type="date"
                                  errorMessage="Masukkan Tanggal Selesai Belajar"
                                  validate={{ required: { value: true } }}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Label className="col-md-3 col-form-label">
                                Negara Penempatan{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col md="9">
                                <Select
                                  name="employee_transfer_detail_country_uuid"
                                  optionLabel="region_name"
                                  optionValue="region_uuid"
                                  placeholder="Negara Penempatan"
                                  errorMessage="Pilih Negara Penempatan"
                                  defaultValue={
                                    detailMutasi?.employee_transfer_detail_country_uuid
                                  }
                                  validate={{ required: { value: true } }}
                                  options={this.state.countryOption}
                                  isLoading={this.state.loadingCountry}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Label className="col-md-3 col-form-label">
                                Nama Kampus{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col md="9">
                                <AvField
                                  name="employee_transfer_detail_study_campus_name"
                                  placeholder="Nama Kampus..."
                                  type="text"
                                  errorMessage="Masukan Nama Kampus"
                                  validate={{ required: { value: true } }}
                                />
                              </Col>
                            </Row>
                          </>
                        )}

                        {this.state.pemberhentianType == 6 && ( // Meninggal Dunia
                          <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                              Tanggal Meninggal Dunia
                              <span className="text-danger">*</span>
                            </Label>
                            <Col md="9">
                              <AvField
                                name="employee_transfer_detail_date_of_death"
                                value={
                                  detailMutasi?.employee_transfer_detail_date_of_death
                                }
                                placeholder="Tanggal Meninggal Dunia..."
                                type="date"
                                errorMessage="Masukkan Tanggal Meninggal Dunia"
                                validate={{ required: { value: true } }}
                              />
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                    {(type == 1 || type == 2 || type == 3) && (
                      <Fragment>
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            Unit Kerja Baru
                            <span className="text-danger">*</span>
                          </Label>
                          <Col md="9">
                            {this.state.selectedMinistry === 1 ? (
                              <Select
                                name="employee_transfer_detail_work_unit_uuid"
                                defaultValue={
                                  detailMutasi
                                    ? detailMutasi?.employee_transfer_detail_work_unit_uuid
                                    : selectedEmployee.employee_current_work_unit_uuid
                                }
                                options={this.state.workUnitOption}
                                optionLabel="work_unit_name_reverse"
                                optionValue="work_unit_uuid"
                                errorMessage="Masukkan Unit Kerja Baru"
                                onChange={(opt) =>
                                  this.loadPosition(opt.work_unit_uuid)
                                }
                                onInputChange={(value) => {
                                  if (value) {
                                    clearTimeout(this.timer);
                                    this.state.workUnitFilter.filter_value =
                                      value;
                                    this.timer = setTimeout(
                                      () => this.loadWorkUnit(),
                                      1000
                                    );
                                  }
                                }}
                                isLoading={this.state.loadingWorkUnit}
                                validate={{ required: { value: true } }}
                              />
                            ) : (
                              <AvField
                                name="employee_transfer_detail_work_unit_name"
                                placeholder="Masukkan Unit Kerja..."
                                type="text"
                                validate={{ required: { value: true } }}
                                value={
                                  detailMutasi?.employee_transfer_detail_work_unit_name
                                }
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            Jenis Jabatan<span className="text-danger">*</span>
                          </Label>
                          <Col md="9">
                            <Select
                              name="employee_transfer_detail_position_type"
                              options={[
                                { value: 1, label: "Struktural" },
                                { value: 2, label: "Fungsional Umum" },
                                { value: 20, label: "Fungsional Tertentu" },
                              ]}
                              errorMessage="Pilih Jenis Jabatan"
                              defaultValue={this.state.position_type}
                              onChange={(opt) =>
                                this.setState(
                                  {
                                    position_type: opt.value,
                                  },
                                  () => this.loadPosition("")
                                )
                              }
                              validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            Jabatan <span className="text-danger">*</span>
                          </Label>
                          <Col md="9">
                            <Select
                              name="employee_transfer_detail_position_uuid"
                              defaultValue={this.state.selected_jabatan}
                              //options={this.state.positionOption}
                              options={this.state.jabatanOption}
                              // optionLabel="position_name"
                              // optionValue="position_uuid"
                              errorMessage="Pilih Jabatan"
                              isLoading={this.state.loadingPosition}
                              validate={{ required: { value: true } }}
                              onChange={(selectedOption) => {
                                // Get the selected value here
                                const selectedValue = selectedOption.value;
                                console.log(
                                  "Selected Position UUID: ",
                                  selectedValue
                                );

                                // Update the state or do something with the selected value
                                // this.setState({
                                //   selectedPosition: selectedValue
                                // });
                                // this.checkQuota(selectedValue);
                              }}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col md="3"></Col>
                          <Col md="9">
                            {this.state.quota >= 0 ? (
                              <Alert color="warning" role="alert">
                                <i className="uil-info-circle"></i> Informasi
                                Penting :
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.msg
                                      ? this.state.msg
                                      : "",
                                  }}
                                />
                              </Alert>
                            ) : null}
                          </Col>
                        </Row>
                      </Fragment>
                    )}

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Surat Keputusan{" "}
                        {this.state.pemberhentianType == 2 ? "Kemenlu" : ""}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="9">
                        <Row>
                          <Col md="6">
                            <AvField
                              name="employee_transfer_detail_decree_number"
                              value={
                                detailMutasi?.employee_transfer_detail_decree_number
                              }
                              placeholder="Nomor SK"
                              type="text"
                              errorMessage="Masukkan No Surat Keputusan"
                              validate={{ required: { value: false } }}
                            />
                          </Col>
                          <Col md="6">
                            <div className="customDatePickerWidth">
                              <DatePicker
                                name="employee_transfer_detail_decree_date"
                                id="employee_transfer_detail_decree_date"
                                placeholder="Tanggal SK"
                                errorMessage="Masukkan Tanggal SK"
                                dateFormat="dd/MM/yyyy"
                                isWeekday={false}
                                value={
                                  detailMutasi?.employee_transfer_detail_decree_date
                                }
                                validate={{ required: { value: false } }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {(type == 2 || type == 3) && (
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          TMT <span className="text-danger">*</span>
                        </Label>
                        <Col md="9">
                          <div className="customDatePickerWidth">
                            <DatePicker
                              name="employee_transfer_detail_tmt_date"
                              id="employee_transfer_detail_tmt_date"
                              placeholder="Tanggal TMT"
                              errorMessage="Masukkan Tanggal TMT"
                              dateFormat="dd/MM/yyyy"
                              isWeekday={false}
                              validate={{ required: { value: true } }}
                            />
                          </div>
                        </Col>
                      </Row>
                    )}
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload Surat Keputusan
                      </Label>
                      <Col md="9">
                        <FileInput
                          name="file"
                          validate={{ required: { value: false } }}
                          maxFiles={1}
                        />
                      </Col>
                    </Row>

                    {(this.state.position_type == 1 ||
                      this.state.position_type == 2 ||
                      this.state.position_type == 20) &&
                      (type == 1 || type == 2) && (
                        <Fragment>
                          {this.state.position_type == 1 &&
                            (type == 1 || type == 2) && (
                              <Fragment>
                                <Row className="mb-3">
                                  <Label className="col-md-3 col-form-label">
                                    Surat Pernyataan Pelantikan
                                  </Label>
                                  <Col md="9">
                                    <Row>
                                      <Col md="6">
                                        <AvField
                                          name="employee_transfer_detail_spp_number"
                                          value={
                                            detailMutasi?.employee_transfer_detail_spp_number
                                          }
                                          placeholder="Nomor SPP"
                                          type="text"
                                          errorMessage="Masukkan No Surat Pernyataan Pelantikan"
                                          validate={{
                                            required: { value: false },
                                          }}
                                        />
                                      </Col>
                                      <Col md="6">
                                        <div className="customDatePickerWidth">
                                          <DatePicker
                                            name="employee_transfer_detail_spp_date"
                                            id="employee_transfer_detail_spp_date"
                                            placeholder="Tanggal SPP"
                                            errorMessage="Masukkan Tanggal SPP"
                                            dateFormat="dd/MM/yyyy"
                                            isWeekday={false}
                                            validate={{
                                              required: { value: false },
                                            }}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>

                                <Row className="mb-3">
                                  <Label className="col-md-3 col-form-label">
                                    Upload Surat Pernyataan Pelantikan
                                  </Label>
                                  <Col md="9">
                                    <FileInput
                                      name="file_spp"
                                      validate={{ required: { value: false } }}
                                      maxFiles={1}
                                    />
                                  </Col>
                                </Row>
                              </Fragment>
                            )}
                          {(this.state.position_type == 1 ||
                            this.state.position_type == 20) &&
                            (type == 1 || type == 2) && (
                              <Fragment>
                                <Row className="mb-3">
                                  <Label className="col-md-3 col-form-label">
                                    Surat Pernyataan Menduduki Jabatan
                                  </Label>
                                  <Col md="9">
                                    <Row>
                                      <Col md="6">
                                        <AvField
                                          name="employee_transfer_detail_spmj_number"
                                          value={
                                            detailMutasi?.employee_transfer_detail_spmj_number
                                          }
                                          placeholder="Nomor SPMJ"
                                          type="text"
                                          errorMessage="Masukkan No Surat Pernyataan Menduduki Jabatan"
                                          validate={{
                                            required: { value: false },
                                          }}
                                        />
                                      </Col>
                                      <Col md="6">
                                        <div className="customDatePickerWidth">
                                          <DatePicker
                                            name="employee_transfer_detail_spmj_date"
                                            id="employee_transfer_detail_spmj_date"
                                            placeholder="Tanggal SPMJ"
                                            errorMessage="Masukkan Tanggal SPMJ"
                                            dateFormat="dd/MM/yyyy"
                                            isWeekday={false}
                                            validate={{
                                              required: { value: false },
                                            }}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                <Row className="mb-3">
                                  <Label className="col-md-3 col-form-label">
                                    Upload Surat Pernyataan Menduduki Jabatan
                                  </Label>
                                  <Col md="9">
                                    <FileInput
                                      name="file_spmj"
                                      validate={{ required: { value: false } }}
                                      maxFiles={1}
                                    />
                                  </Col>
                                </Row>
                              </Fragment>
                            )}

                          <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                              Surat Pernyataan Melaksakan Tugas
                            </Label>
                            <Col md="9">
                              <Row>
                                <Col md="6">
                                  <AvField
                                    name="employee_transfer_detail_spmt_number"
                                    value={
                                      detailMutasi?.employee_transfer_detail_spmt_number
                                    }
                                    placeholder="Nomor SPMT"
                                    type="text"
                                    errorMessage="Masukkan No Surat Pernyataan Melaksakan Tugas"
                                    validate={{ required: { value: false } }}
                                  />
                                </Col>
                                <Col md="6">
                                  <div className="customDatePickerWidth">
                                    <DatePicker
                                      name="employee_transfer_detail_spmt_date"
                                      id="employee_transfer_detail_spmt_date"
                                      placeholder="Tanggal SPMT"
                                      errorMessage="Masukkan Tanggal SPMT"
                                      dateFormat="dd/MM/yyyy"
                                      isWeekday={false}
                                      validate={{ required: { value: false } }}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                              Upload Surat Pernyataan Melaksakan Tugas
                            </Label>
                            <Col md="9">
                              <FileInput
                                name="file_spmt"
                                validate={{ required: { value: false } }}
                                maxFiles={1}
                              />
                            </Col>
                          </Row>
                        </Fragment>
                      )}

                    {type == 3 && (
                      <Fragment>
                        {this.state.pemberhentianType === 2 && (
                          <Fragment>
                            <Row className="mb-3">
                              <Label className="col-md-3 col-form-label">
                                Jenis Jabatan{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col md="9">
                                <Select
                                  name="employee_transfer_detail_position_type"
                                  placeholder="Jenis Jabatan..."
                                  errorMessage="Pilih Jenis Jabatan"
                                  defaultValue={
                                    detailMutasi?.employee_transfer_detail_position_type
                                  }
                                  validate={{ required: { value: true } }}
                                  options={[
                                    {
                                      value: 1,
                                      label: "Pejabat Promosi Investasi",
                                    },
                                    {
                                      value: 2,
                                      label:
                                        "Pembantu Pejabat Promosi Investasi",
                                    },
                                  ]}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Label className="col-md-3 col-form-label">
                                Negara Penempatan{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col md="9">
                                <Select
                                  name="employee_transfer_detail_country_uuid"
                                  optionLabel="region_name"
                                  optionValue="region_uuid"
                                  placeholder="Negara Penempatan..."
                                  errorMessage="Pilih Negara Penempatan"
                                  defaultValue={
                                    detailMutasi?.employee_transfer_detail_country_uuid
                                  }
                                  validate={{ required: { value: true } }}
                                  options={this.state.countryOption}
                                  isLoading={this.state.loadingCountry}
                                />
                              </Col>
                            </Row>
                          </Fragment>
                        )}
                      </Fragment>
                    )}
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Pejabat Penetap <span className="text-danger">*</span>
                      </Label>
                      <Col md="9">
                        <AvField
                          name="employee_transfer_detail_signatories_official"
                          value={
                            detailMutasi?.employee_transfer_detail_signatories_official
                          }
                          placeholder="Pejabat Penetap..."
                          type="text"
                          errorMessage="Masukkan Pejabat Penetap"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    {(type == 1 || type == 2) && this.state.is_internal == 1 ? (
                      <>
                        <Row className="mb-3">
                          <label
                            htmlFor="mapping_grade_tunsus_grade_special_level_uuid"
                            className="col-md-3 col-form-label"
                          >
                            Grade Tunsus <span className="text-danger">*</span>
                          </label>
                          <Col md="3">
                            <Select
                              name="mapping_grade_tunsus_grade_special_level_uuid"
                              placeholder="Grade Tunsus..."
                              errorMessage="Grade Tunsus"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              options={this.state.gradeListOption}
                              optionLabel="special_level_code"
                              optionValue="special_level_uuid"
                              isLoading={!this.state.gradeListOption?.length}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <label
                            htmlFor="mapping_grade_tunsus_grade_special_level_uuid"
                            className="col-md-3 col-form-label"
                          >
                            Berlaku Dari <span className="text-danger">*</span>
                          </label>
                          <Col md="3">
                            <AvField
                              name={`mapping_grade_tunsus_grade_start_date`}
                              type="date"
                              errorMessage="MasukkanTanggal Mulai Berlaku"
                              validate={{ required: { value: true } }}
                              placeholder="Tanggal Mulai Berlaku"
                            />
                          </Col>
                        </Row>

                        {/* Penambahan untuk PPPK  */}
                        {this.state.is_pppk === 1 && (
                          <>
                            {/* Penambahan untuk PPPK  */}
                            <Row className="mb-3">
                              <label
                                htmlFor="perpanjang_kontrak"
                                className="col-md-3 col-form-label"
                              >
                                Perpanjang Kontrak
                              </label>
                              <Col md="5">
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="perpanjang_kontrak_is_checked"
                                  value=""
                                  checked={
                                    this.state.perpanjang_kontrak_is_checked
                                  }
                                  onChange={(event) => {
                                    this.toggleCheckbox();
                                  }}
                                />
                                <AvField
                                  name="perpanjang_kontrak_is_checked"
                                  type="hidden"
                                  value={
                                    this.state.perpanjang_kontrak_is_checked
                                  }
                                />
                              </Col>
                            </Row>

                            {this.state.perpanjang_kontrak_is_checked ===
                              true && (
                              <>
                                <Row className="mb-3">
                                  <Label className="col-md-3 col-form-label">
                                    Tanggal TMT Berakhir{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Col md="9">
                                    <div className="customDatePickerWidth">
                                      <DatePicker
                                        name="employee_transfer_detail_tmt_date_end"
                                        id="employee_transfer_detail_tmt_date_end"
                                        placeholder="Tanggal TMT Berakhir"
                                        errorMessage="Masukkan Tanggal TMT Berakhir"
                                        dateFormat="dd/MM/yyyy"
                                        isWeekday={false}
                                        validate={{ required: { value: true } }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </>
                        )}
                      </>
                    ) : null}

                    {type == 3 && this.state.pemberhentianType == 2 && (
                      <Fragment>
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            Upload SK Kemenlu{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Col md="9">
                            <FileInput
                              name="employee_transfer_detail_kemenlu_decree_document"
                              // col={6}
                              validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            Pasangan yang Ikut
                          </Label>
                          <Col md="9">
                            <Select
                              name="employee_transfer_detail_couple_uuid"
                              optionLabel="name"
                              optionValue="family_uuid"
                              placeholder="Pilih Pasangan yang Ikut"
                              errorMessage="Pilih Pasangan yang Ikut"
                              defaultValue={
                                detailMutasi?.employee_transfer_detail_couple_uuid
                              }
                              validate={{ required: { value: false } }}
                              options={this.state.coupleOption}
                              isLoading={this.state.loadingCouple}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            Anak yang Ikut
                          </Label>
                          <Col md="9">
                            <Select
                              isMulti
                              name={`employee_transfer_detail_child_uuid`}
                              options={this.state.childOption}
                              optionLabel="family_name"
                              optionValue="family_uuid"
                              placeholder="Pilih Anak yang Ikut"
                              validate={{ required: { value: false } }}
                              onChange={(selectedOption) =>
                                this.setState({
                                  selectedChild: selectedOption.map(
                                    (option) => option.family_uuid
                                  ),
                                })
                              }
                              isLoading={this.state.childOption}
                            />
                            <AvField
                              type="hidden"
                              name="employee_transfer_detail_child_uuid"
                              value={this.state.selectedChild}
                              validate={{ required: { value: false } }}
                              errorMessage="Pilih Anak yang Ikut"
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            Upload Surat Pernyataan Anggota Keluarga
                          </Label>
                          <Col md="9">
                            <FileInput
                              name="employee_transfer_detail_family_document"
                              // col={6}
                            />
                            <div
                              style={{ color: "rgb(59 130 246)" }}
                              onClick={() => {
                                this.createBloc.fetchDownloadTemplate({
                                  employee_transfer_detail_employee_uuid:
                                    selectedEmployee.employee_uuid,
                                });
                              }}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Unduh template...
                            </div>
                          </Col>
                        </Row>
                      </Fragment>
                    )}

                    {/* Penambahan Pemadanan  */}
                    <Row className="mb-3">
                        <label
                          htmlFor="employee_transfer_detail_employee_status_uuid"
                          className="col-md-3 col-form-label"
                        >
                          Status Pegawai <span className="text-danger">*</span>
                        </label>
                        <Col md="3">
                          <Select
                            name="employee_transfer_detail_employee_status_uuid"
                            placeholder="Status Pegawai..."
                            errorMessage="Status Pegawai"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            options={this.state.statusListOption}
                            optionLabel="label"
                            optionValue="value"
                            isLoading={!this.state.statusListOption?.length}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <label
                          htmlFor="employee_transfer_detail_legal_position_status_uuid"
                          className="col-md-3 col-form-label"
                        >
                          Kedudukan Hukum <span className="text-danger">*</span>
                        </label>
                        <Col md="3">
                          <Select
                            name="employee_transfer_detail_legal_position_status_uuid"
                            placeholder="Kedudukan Hukum..."
                            errorMessage="Kedudukan Hukum"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            options={this.state.legalListOption}
                            optionLabel="label"
                            optionValue="value"
                            isLoading={!this.state.legalListOption?.length}
                          />
                        </Col>
                      </Row>

                       {/* Tambahan Untuk Reset Angka Kredit */}
                      <Row className="mb-3">
                        <label className="col-md-3 col-form-label"></label>
                        <Col md="8" className="d-flex align-items-center">
                          <div className="custom-checkbox">
                            <input
                              type="checkbox"
                              id="resetAkCheckbox"
                              checked={this.state.confirmResetAk}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  this.setState({ modalResetAk: true });
                                } else {
                                  this.setState({
                                    isResetAk: false,
                                    confirmResetAk: false
                                  });
                                }
                              }}
                            />
                            <label htmlFor="resetAkCheckbox">
                              Jika di checklist, maka akan mereset angka kredit
                            </label>
                          </div>
                          
                          {/* Hidden AvCheckbox untuk form validation */}
                          <AvCheckboxGroup
                            name="employee_transfer_detail_is_reset_ak"
                            value={this.state.confirmResetAk ? ["1"] : []}
                            style={{ display: 'none' }}
                          >
                            <AvCheckbox value="1" />
                          </AvCheckboxGroup>
                          
                          <style>
                            {`
                              .custom-checkbox {
                                display: flex;
                                align-items: center;
                              }
                              .custom-checkbox label {
                                display: flex;
                                align-items: center;
                                font-size: 14px;
                                line-height: 1.5;
                                cursor: pointer;
                                margin: 0;
                                margin-left: 0;
                              }
                              .custom-checkbox input[type="checkbox"] {
                                width: 16px;
                                height: 16px;
                                margin-right: 10px;
                                margin-top: 0 !important;
                                cursor: pointer;
                                flex-shrink: 0;
                              }
                            `}
                          </style>
                        </Col>
                      </Row>


                  </Fragment>
                )}
              </Collapse>

              <ModalFooter>
                <Button color="secondary" onClick={this.props.toggle}>
                  Cancel
                </Button>{" "}
                {this.state.quota < 0 && (
                  <Button color="primary" type="submit">
                    Submit
                  </Button>
                )}
              </ModalFooter>
            </AvForm>
          </ModalBody>
        </Modal>

        <Modal isOpen={this.state.modalResetAk} toggle={this.toggleModalResetAk} centered>
          <ModalHeader toggle={this.toggleModalResetAk}>
            Konfirmasi Reset Angka Kredit
          </ModalHeader>
          <ModalBody>
            <p className="mb-0">Apakah Anda yakin akan mereset angka kredit?</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.handleCancelResetAk}>
              Tidak
            </Button>
            <Button color="primary" onClick={this.handleConfirmResetAk}>
              Ya
            </Button>
          </ModalFooter>
        </Modal>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          // failedInfo={this.state.failedInfo}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />

        {/* Alert Untuk pegawai yang belum mengembalikan aset pada aplikasi BMN  failedInfo2, showFailed2*/}
        <ErrorAlert
          response={this.confirmResponse2}
          failedInfo={this.state.failedInfoBmn}
          showFailed={this.state.failedBmn}
        />
      </Fragment>
    );
  }
}

export default withRouter(CreateModal);
